(() => {
  let cleanup;
  const initialize = () => {
    cleanup?.();
    const section = document.querySelector('[data-product-section]');
    const form = section?.querySelector('.syk-product-form');
    if (!form) return;
    const primary = form.querySelector('[data-add-button]');
    const select = form.querySelector('[data-variant-select]');
    const qty = form.querySelector('[name="quantity"]');
    const bar = document.createElement('div');
    bar.className = 'syk-sticky-buy';
    bar.hidden = true;
    bar.setAttribute('aria-label', 'Your product selection');
    const info = document.createElement('div'); info.className = 'syk-sticky-buy-info';
    const title = document.createElement('span'); title.className = 'syk-sticky-buy-title'; title.textContent = section.querySelector('h1').textContent;
    const choice = document.createElement('span'); choice.className = 'syk-sticky-buy-selection';
    const actions = document.createElement('div'); actions.className = 'syk-sticky-buy-actions';
    const price = document.createElement('span'); price.className = 'syk-sticky-buy-price';
    const buy = document.createElement('button'); buy.type = 'button'; buy.className = 'syk-button';
    info.append(title, choice); actions.append(price, buy); bar.append(info, actions); document.body.append(bar);
    const sync = () => {
      price.textContent = section.querySelector('[data-variant-price]').textContent;
      choice.textContent = [select?.selectedOptions[0]?.textContent, 'Qty ' + qty.value].filter(Boolean).join(' · ');
      buy.textContent = primary.textContent;
      buy.disabled = primary.disabled;
    };
    const onSubmit = () => {
      sync();
      // The original form owns inventory checks, errors, quantity and selected variant.
      form.requestSubmit(primary);
    };
    buy.addEventListener('click', onSubmit);
    form.addEventListener('change', sync);
    form.addEventListener('input', sync);
    const observer = new MutationObserver(sync); observer.observe(primary, {childList: true, attributes: true}); observer.observe(section.querySelector('[data-variant-price]'), {childList: true});
    const intersection = new IntersectionObserver(entries => {
      const entry = entries[0];
      bar.hidden = entry.isIntersecting || (!window.matchMedia('(max-width: 749px)').matches && entry.boundingClientRect.bottom > 0);
    }, {threshold: 0});
    intersection.observe(section.querySelector('.syk-buy-row'));
    const resize = new ResizeObserver(() => {document.body.style.paddingBottom = bar.hidden ? '' : bar.offsetHeight + 'px';}); resize.observe(bar);
    sync();
    cleanup = () => {observer.disconnect(); intersection.disconnect(); resize.disconnect(); form.removeEventListener('change', sync); form.removeEventListener('input', sync); bar.remove(); document.body.style.paddingBottom = '';};
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
